import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'

class PaymentConfirmation extends PureComponent {
  render () {
    return (
      <div className='account'>
        <div className='account__wrapper'>
          <div className='account__card'>
            <div className='account__head'>
              <h3 className='account__title'>Purchase Complete</h3>
              <h4
                id='header'
                className='account__subhead subhead'>
                Access your <Link to='/app/dashboard'>Dashboard </Link> here
              </h4>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PaymentConfirmation



// WEBPACK FOOTER //
// ./src/components/e-commerce/payment/components/PaymentConfirmation.js